import { FC } from 'react';
import { HarmReportDetailsProps } from './harmReports.type';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createHarmReportConfig } from '../../component/reportDetails/harmReportConfig';
import { getHarmReportsKebabOptions } from './harmReportesHelper';

export const HarmReportDetails: FC<HarmReportDetailsProps> = (props) => {
  const { harmReport } = props;
  const config = createHarmReportConfig(harmReport);

  return (
    <ReportDetails
      config={config}
      onClose={props.closeHarmReportDetails}
      onReviewAndSign={props.handleReviewAndSignClick}
      kebabOptions={getHarmReportsKebabOptions(harmReport, null, 0)
        .filter((o) => o.label !== 'View')
        .map((o) => ({
          label: o.label,
          optionKey: o.label,
        }))}
      onKebabAction={props.onKebabAction}
    />
  );
};
